<template>
    <div class="reportForWeek">
        <div class="reportForWeek-title">
            <div>
                Итоги <span style="margin-right: 8px;">{{$datef(dayData.Date,'d')}}</span> <span :class="profit < 0 ? 'color-red':'color-green'" style="margin-right: 8px;">$ {{$moneyf(profit)}}</span> <span :class="profit < 0 ? 'color-red':'color-green'" style="margin-right: 8px;">%{{$moneyf(profitPercent)}}</span>
            </div>
            <i class="icon-close" @click="closeReport"></i>
        </div>
        <div class="reportForWeek-title">
            <div><span>ОТКРЫТЫЕ ПОЗИЦИИ</span> ВСЕГО ЗА ДЕНЬ Было открыто <span>{{openPositions.length}}</span> сделок (совокупно)</div>
        </div>
        <preloader v-if="loading" />
        <table v-show="!loading" class="reportTable">
            <tr class="reportTable-title">
                <td>Ордер</td>
                <td>Тип</td>
                <td>Объём</td>
                <td>Вход</td>
            </tr>
            <tr v-for="(item,index) in getReportDataOpenPositionsBySymbol" :key="index">
                <td>{{item.symbol}}</td>
                <td :class="item.cmd < 0 ? 'color-red' : 'color-green'">{{item.cmd < 0 ? 'SELL' : 'BUY'}}</td>
                <td>{{$moneyf(item.volume)}}</td>
                <td>{{item.price}}</td>
            </tr>
        </table>
        <div style="border-top: solid #293546 1px;" class="reportForWeek-title">
            <div><span>ЗАКРЫТЫЕ ПОЗИЦИИ</span> ВСЕГО ЗА ДЕНЬ Было закрыто <span>{{closePositions.length}}</span> СДЕЛОК (совокупно)</div>
        </div>
        <preloader v-if="loading" />
        <table v-show="!loading" class="reportTable">
            <tr class="reportTable-title">
                <td>Ордер</td>
                <td>Тип</td>
                <td>Объём</td>
                <td>PL,$</td>
                <td>PL,%</td>
                <td>PL,P</td>
            </tr>
            <tr v-for="(item,index) in getReportDataClosePositionsBySymbol" :key="index + 'c'">
                <td>{{item.symbol}}</td>
                <td :class="item.cmd < 0 ? 'color-red':'color-green'">{{item.cmd < 0 ? 'SELL' : 'BUY'}}</td>
                <td>{{item.volume}}</td>
                <td :class="item.plDepo < 0 ? 'color-red':'color-green'">{{$moneyf(item.plDepo)}}</td>
                <td :class="item.plDepo < 0 ? 'color-red':'color-green'">{{$moneyf(item.plRel)}}</td>
                <td :class="item.plDepo < 0 ? 'color-red':'color-green'">{{$moneyf(item.plPoint)}}</td>
            </tr>
            <tr>
                <td colspan="2">ИТОГО:</td>
                <td>{{getSummaryProfits.volume}}</td>
                <td :class="getSummaryProfits.plDepo < 0 ? 'color-red':'color-green'">{{$moneyf(getSummaryProfits.plDepo)}}</td>
                <td :class="getSummaryProfits.plRel < 0 ? 'color-red':'color-green'">{{$moneyf(getSummaryProfits.plRel)}}</td>
                <td :class="getSummaryProfits.plPips < 0 ? 'color-red':'color-green'">{{getSummaryProfits.plPips ? getSummaryProfits.plPips.toFixed(2) : 0}}</td>
            </tr>
        </table>
        <div class="reportForWeek-title" style="border-top: solid #293546 1px;">
            <div>ГРАФИК ДОХОДА <span>{{$datef(dayData.Date,'d')}}</span></div>
        </div>
        <div class="reportForWeek-chart">
            <DayChart :dayDate="new Date(dayData.Date).getDate()" @getProfit="setProfit($event)"/>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import {mapGetters} from 'vuex';
import DayChart from './chartForReportDay';
import preloader from '../../../ui-components/preloader'
export default {
    components: {
        DayChart,
        preloader
    },
    props:['dayData'],
    data() {
        return {
            openPositions:[],
            closePositions:[],
            loading:true,
            profit:0,
            profitPercent:0
        }
    },
    computed: {
        ...mapGetters({
              getRestUri:'api/getApiUri',
              getCropStat: 'accountstat/getCroppedStatBySymbol',
        }),
        getReportDataOpenPositionsBySymbol() {
            if(this.openPositions.length === 0)
                return 0
            let arrSymbols = getSymbolPair(this.openPositions);
            let result = []
            for(let i = 0; i < arrSymbols.length; i++) {
                result.push({
                    symbol:arrSymbols[i],
                    volume:getVolumeBySymbol(arrSymbols[i], this.openPositions),
                    price: getAverPrice(arrSymbols[i], this.openPositions),
                    cmd:getCmdBySymbol(arrSymbols[i], this.openPositions),
                })
            }
            return result;
        },
        getReportDataClosePositionsBySymbol() {
            if(this.closePositions.length === 0)
                return 0;
            let arrSymbols = getSymbolPair(this.closePositions);
            let result = []
            for(let i = 0; i < arrSymbols.length; i++) {
                result.push({
                    symbol:arrSymbols[i],
                    volume:getVolumeBySymbol(arrSymbols[i], this.closePositions),
                    price: getAverPrice(arrSymbols[i], this.closePositions),
                    cmd:getCmdBySymbol(arrSymbols[i], this.closePositions),
                    plDepo:getProfitBySymbol(arrSymbols[i], this.closePositions).plDepo,
                    plRel:getProfitBySymbol(arrSymbols[i], this.closePositions).plDepo/this.getCropStat().Summary.Equity*100,
                    plPoint:getProfitBySymbol(arrSymbols[i], this.closePositions).plPoint
                })
            }
            return result;
        },
        pointsForChart() {
            return getPointsForChart(this.weekData)
        }, 
        getSummaryProfits() {
            let arrClosePos = this.getReportDataClosePositionsBySymbol
            if(arrClosePos.length === 0)
                return
            let profits = {
                plDepo:0,
                plRel:0,
                plPips:0,
                volume:0
            }
            if(arrClosePos.length === 1) {
                profits = {
                    plDepo:arrClosePos[0].plDepo,
                    plRel:arrClosePos[0].plRel,
                    plPips:arrClosePos[0].plPoint,
                    volume:arrClosePos[0].volume
                }
            } else {
                for(let i = 1; i < arrClosePos.length; i++) {
                    profits = {
                        plDepo: arrClosePos[0].plDepo+=arrClosePos[i].plDepo,
                        plRel: arrClosePos[0].plRel+=arrClosePos[i].plRel,
                        plPips: arrClosePos[0].plPoint+=arrClosePos[i].plPoint,
                        volume: arrClosePos[0].volume+=arrClosePos[i].volume
                    }
                }
            }
            return profits
        }
    },
    methods: {
        createReport(data) {
            this.loading = true;
            let stamp = new Date(data.Date).getTime()/1000 - 60*1440;
            let uri = this.getRestUri + 'statistics/bytimestamp?accountIds=949&time=' + stamp;
            axios.get(uri).then(
                response => {
                    this.openPositions = getOpenPositions(response.data, data.Date);
                    this.closePositions = getClosedPositions(response.data, data.Date);
                    this.loading = false;
                }
            )
        },
        closeReport() {
            this.$emit('close');
        },
        setProfit(profit) {
            this.profit = profit.profitDepo;
            this.profitPercent = profit.profitPercent
        }
    },
    watch: {
        dayData:function() {
            this.createReport(this.dayData);
        }
    },
    created() {
        this.createReport(this.dayData);
    }
}
function getOpenPositions(positions, dateData) {
    let dateDay = new Date (dateData).getDate();
    let dateMoth = new Date (dateData).getMonth();
    let dateYear = new Date (dateData).getFullYear();
    let openPositions = [];
    let closePositions = [];
    for(let i = 0; i < positions.OpenedOrders.length; i++) {
        if(new Date (positions.OpenedOrders[i].timeEnter).getDate() === dateDay && new Date (positions.OpenedOrders[i].timeEnter).getMonth() === dateMoth && new Date (positions.OpenedOrders[i].timeEnter).getFullYear() === dateYear) 
            openPositions.push(positions.OpenedOrders[i])
    }
    for(let i = 0; i < positions.ClosedOrders.length; i++) {
        if(new Date (positions.ClosedOrders[i].timeEnter).getDate() === dateDay && new Date (positions.ClosedOrders[i].timeEnter).getMonth() === dateMoth && new Date (positions.ClosedOrders[i].timeEnter).getFullYear() === dateYear)
            closePositions.push(positions.ClosedOrders[i])
    }
    let allPositions = [...openPositions, ...closePositions]
    return allPositions;
}
function getClosedPositions(positions, dateData) {
    let dateDay = new Date (dateData).getDate();
    let dateMoth = new Date (dateData).getMonth();
    let dateYear = new Date (dateData).getFullYear();
    let closePositions = [];
    for(let i = 0; i < positions.ClosedOrders.length; i++) {
        if(new Date (positions.ClosedOrders[i].timeExit).getDate() === dateDay && new Date (positions.ClosedOrders[i].timeExit).getMonth() === dateMoth && new Date (positions.ClosedOrders[i].timeExit).getFullYear() === dateYear)
            closePositions.push(positions.ClosedOrders[i])
    }
    return closePositions;
}
function getSymbolPair(arr) {
    let symbols = {};
    for (let i = 0; i < arr.length; i++) {
        let str = arr[i].symbol;
        symbols[str] = str;
    }
    return Object.keys(symbols);
}
function getVolumeBySymbol(symbol, arr) {
    let sumVolume = 0
    for (let i = 0; i < arr.length; i++) {
        if(arr[i].symbol === symbol)
        sumVolume+=arr[i].volume
    }
    return sumVolume;
}
function getAverPrice(symbol, arr) {
    let sumPrice = 0;
    let cnt = 0;
    for (let i = 0; i < arr.length; i++) {
        if(arr[i].symbol === symbol) {
            sumPrice+=arr[i].priceEnter
            cnt++
        }
    }
    return (sumPrice/cnt).toFixed(5);
}
function getCmdBySymbol(symbol, arr) {
    let cntSELL = 0;
    let cntBUY = 0;
    for (let i = 0; i < arr.length; i++) {
        if(arr[i].symbol === symbol) {
            arr[i].side === 1 ? cntBUY++ : cntSELL++
        }
    }
    return cntBUY < cntSELL ? -1 : 1
}
function getProfitBySymbol(symbol, arr) {
    let pl = 0;
    let plP = 0;
    for (let i = 0; i < arr.length; i++) {
        if(arr[i].symbol === symbol) {
            pl+=arr[i].resultDepo;
            plP+=arr[i].resultPoint;
        }
    }
    let profits = {
       plDepo:pl,
       plPoint:plP
    }
    return profits
}
function getPointsForChart(arr) {
    let points=[];
    for(let i = 0; i < arr.length - 1; i++)
        points.push(arr[i].equityOnEod);
    return points;
}
</script>
<style lang="less" scoped>
.bigBorder {
    border-bottom: solid #293546 3px !important; 
}
.reportForWeek {
    background: #324258;
    border-left:1px solid #293546;
    font-family: Arimo;
    font-size: 14px;
    width: 600px;
    line-height: 1.24;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    box-sizing: border-box;
    @media screen and (max-width: 1981px) { 
        padding-bottom: 38px;
    }
    &-closeIcon {
        width: 100%;
        text-align: right;
    }
    &-title {
        border-bottom: solid #293546 1px;
        height: 36px;
        align-items: center;
        font-family: Arimo;
        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.4px;
        padding-left: 14px;
        color: #9cacc6;
        background:   #324259;
        text-transform: uppercase;
        display: flex;
        justify-content: space-between;
        
        span {
            color:#fff;
        }
        i {
            font-size: 18px;
            margin-right: 8px;
            margin-top: -3px;
            cursor: pointer;
        }
        &-white {
            color:#fff;
        }
    }
    &-rowData {
        height: 30px;
        font-size: 12px;
        padding: 8px;
        box-sizing: border-box;
        color:#9FB6D2;
        text-transform: uppercase;
        display: flex;
        &_symbol {
            width:80px;
            color:#fff;
            font-weight: bold;
        }
        &_cmd {
            width:60px;
        }
        &_volume {
            width: 125px;
            span {
                color:#fff;
            }
        }
        &_price {
            span {
                color:#fff;
            }
        }
    }
    &-summary {
        display: flex;
    }
    &-summaryData {
        min-width: 300px;
        flex-grow: 0;
        &-item {
            height: 30px;
            font-size: 12px;
            padding: 8px;
            box-sizing: border-box;
            color:#9FB6D2;
            text-transform: uppercase;
            span {
                color:#fff;
            }
        }
    }
    &-chart {
        height: 450px;
    }
}
.reportTable {
    width: 100%;
    tr {
        height: 36px;
        border-bottom: 1px solid #293546;
    }
    td {
        padding-left: 14px;
        border-right: 1px solid #293546;
    }
    &-title {
        font-family: Arimo;
        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.4px;
        color: #9cacc6;
        text-transform: uppercase;
    }
}
</style>